import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { getMachineConnectionMethod } from '@reducers/machines';
import { MachineConnectionMethod } from '@api/domain';
import { useFetch } from '@api/hooks/useFetch';

export const useGetMachineConnectionMethods = () => {
  const dispatch = useAppDispatch();

  const {
    data: machineConnectionMethods,
    loading,
    refetch,
  } = useFetch<MachineConnectionMethod[]>({
    fetchFn: async () => {
      const response = await dispatch(getMachineConnectionMethod());
      return response || null;
    },
    deps: [],
  });

  return { machineConnectionMethods, loading, refetch };
};
